<template>
  <div>
    <div class="apply-school">
      <div class="show-wapper">
        <div class="editUnivName">
          <div>
            <span><i class="annotation">*</i>学校中文名:</span>
            <!--对单联合双向联动做出区别 isDoble 传入对应字段-->
            <jm-Search
              clearable
              class="jm-input230"
              v-model="majormes"
              get-value="schoolname"
              :get-other-value="['schoolename', 'sh_id']"
              get-type="sh_name_cn"
              :getother-type="['sh_name_en', 'sh_id']"
              :is-doble="true"
              :country-id="majormes.country_id"
              get-url='/index/api_base/searchSchool'
            />
          </div>
          <div>
            <span><i class="annotation">*</i>学校英文名:</span>
            <jm-Search
              clearable
              class="jm-input230"
              v-model="majormes"
              get-value="schoolename"
              :get-other-value="['schoolname', 'sh_id']"
              get-type="sh_name_en"
              :getother-type="['sh_name_cn', 'sh_id']"
              get-list="sh_name_en"
              :country-id="majormes.country_id"
              :is-doble="true"
              get-url='/index/api_base/searchSchool'
            />
          </div>
        </div>
        <div class="professional">
          <div class="hide">
            <div class="discInfo">
              <div class="prompting-wapper">
                <div class="inputWrap">
                  <span><i class="annotation">*</i>意向课程:</span>
                  <jm-dict-select
                    class="jm-input175"
                    clearable
                    type="online"
                    dict-type="course"
                    :filter="filterPid"
                    v-model="majormes.custom_course"/>
                </div>
                <input
                  v-validate="'required|customCourse'"
                  style="display: none;"
                  name="customCourse"
                  v-model="majormes.custom_course">
                <p><span
                  class="errors"
                  v-if="errors.has('customCourse')" >*{{ errors.first('customCourse') }}</span></p>
              </div>
              <div class="prompting-wapper">
                <div class="inputWrap">
                  <span>专业方向:</span>
                  <jm-dict-select
                    class="jm-input175"
                    clearable
                    type="college"
                    dict-type="direction"
                    :filter="getPid"
                    name="college"
                    v-model="majormes.custom_hope_way"/>
                </div>
                <!--                <input-->
                <!--                  v-validate="'required|customHopeWay'"-->
                <!--                  style="display: none;"-->
                <!--                  name="customHopeWay"-->
                <!--                  v-model="majormes.custom_hope_way">-->
                <!--                <p><span-->
                <!--                  class="errors"-->
                <!--                  v-if="errors.has('customHopeWay')" >*{{ errors.first('customHopeWay') }}</span></p>-->
              </div>
              <div
                class="inputWrap"
                v-if="majormes.country_id !== 673">
                <span>申请费用(<jm-dict-select
                  class="jm-fl"
                  type="dataset"
                  :show="true"
                  v-model="majormes.country_id"
                  dict-type="student"
                  name="countryMoney"/>):</span>
                <el-input
                  v-model="majormes.shenqing_xuefei"
                  name="applyMoney"
                  placeholder="请输入内容"/>
                  <!--                <p><span-->
                  <!--                  class="errors"-->
                  <!--                  v-if="errors.has('applyMoney')" >*{{ errors.first('applyMoney') }}</span></p>-->
              </div>
              <div
                class="inputWrap"
                v-if="majormes.country_id === 31 || majormes.country_id === 673">
                <span>CRICOS code:</span>
                <el-input
                  v-model="majormes.ex5"
                  placeholder="请输入"/>
              </div>
            </div>
            <div class="degreeType">
              <div class="prompting-wapper">
                <div class="inputWrap">
                  <span><i class="annotation">*</i>申请专业:</span>
                  <!--多项目联动时候oldOtherValue和otherYype为数组 注意要一一对应-->
                  <jm-Search
                    clearable
                    class="jm-input100"
                    v-model="majormes"
                    get-value="zhuanye_name"
                    :get-other-value="['xuewei_type', 'weburl','ielts_pro','small_score','yuyan']"
                    get-type="zhuanye_name"
                    :getother-type="['xuewei_type', 'weburl','ielts_pro','small_score','yuyan']"
                    get-list="zhuanye_name"
                    :sh-id="majormes.sh_id"
                    get-url='/index/api_base/serachProfessional'/>
                </div>
                <input
                  v-validate="'required|zhuanyeName'"
                  style="display: none;"
                  name="zhuanyeName"
                  v-model="majormes.zhuanye_name">
                <p><span
                  class="errors"
                  v-if="errors.has('zhuanyeName')" >*{{ errors.first('zhuanyeName') }}</span></p>
              </div>
              <div
                class="prompting-wapper"
                style="width: 30%">
                <div class="inputWrap"
                     v-if="majormes.country_id !== 673">
                  <span>学位类型:</span>
                  <el-input
                    v-model="majormes.xuewei_type"
                    placeholder="请输入内容"/>
                </div>
                <input
                  v-if="majormes.country_id !== 673"
                  style="display: none;"
                  name="xueweiType"
                  v-model="majormes.xuewei_type">
                  <!--                <p><span-->
                  <!--                  class="errors"-->
                  <!--                  v-if="errors.has('xueweiType') && majormes.country_id !== 673" >*{{ errors.first('xueweiType') }}</span></p>-->
              </div>
            </div>
            <div class="inter">
              <div
                class="inputWrap"
                style="width: 95%">
                <el-input
                  placeholder="请输入内容"
                  v-model="majormes.weburl">
                  <template slot="prepend"><i class="annotation">*</i>网址:</template>
                </el-input>
              </div>
              <input
                v-validate="'required|weburl'"
                style="display: none;"
                name="weburl"
                v-model="majormes.weburl">
              <p><span
                class="errors"
                v-if="errors.has('weburl')" >*{{ errors.first('weburl') }}</span></p>
            </div>
            <div class="degreeType coll">
              <div class="inputWrap">
                <span><i v-if="majormes.country_id === 30 || majormes.country_id === 31" class="annotation">*</i>学制:</span>
                <el-input
                  v-validate="'required|inputEx2'"
                  style="width: 300px"
                  name="inputEx2"
                  v-model="majormes.ex2"
                  placeholder="请输入内容"/>
                <p><span class="errors" v-if="errors.has('inputEx2')" >*{{ errors.first('inputEx2') }}</span></p>
              </div>
              <div
                class="inputWrap"
                style="width: 30%">
                <span>学部:</span>
                <el-input
                  v-model="majormes.ex3"
                  name="inputEx3"
                  placeholder="请输入内容"/>
                  <!--                <p><span class="errors" v-if="errors.has('inputEx3')" >*{{ errors.first('inputEx3') }}</span></p>-->
              </div>
            </div>
            <el-input
              style="margin: 8px;width: 95%"
              type="textarea"
              :autosize="{ minRows: 10}"
              name="mainCourses"
              placeholder="主要课程:"
              v-model="majormes.zhuyaokecheng"/>
            <!--            <p><span class="errors" v-if="errors.has('mainCourses')" >*{{ errors.first('mainCourses') }}</span></p>-->
            <el-input
              style="margin: 8px;width: 95%"
              type="textarea"
              name="inputEx1"
              :autosize="{ minRows: 4}"
              placeholder="录取要求:"
              v-model="majormes.ex1"/>
            <!--            <p><span class="errors" v-if="errors.has('inputEx1')" >*{{ errors.first('inputEx1') }}</span></p>-->
            <el-input
              style="margin: 8px;width: 95%"
              type="textarea"
              name="inputMemo"
              :autosize="{ minRows: 4}"
              placeholder="备注:"
              v-model="majormes.memo"/>
            <div class="gpa-list">
              <p style="margin-bottom: 20px"><span>语言要求:</span></p>
              <div class="gpa">
                <div class="gpa-group jm-fl">
                  <div>
                    <span class="gpa-span">IELTS:</span><el-input
                      name="ieltsPro"
                      style="width: 74px;margin-right: 10px"
                      v-model="majormes.ielts_pro"
                      placeholder="总分"/>
                  </div>
                  <!--                  <p style="float: left;white-space: pre;">-->
                  <!--                    <span-->
                  <!--                      class="errors"-->
                  <!--                      v-if="errors.has('ieltsPro')" >*{{ errors.first('ieltsPro') }}</span>-->
                  <!--                  </p>-->
                </div>
                <div class="gpa-group jm-fl">
                  <div>
                    <span class="gpa-span">各小分不低于:</span><el-input
                      name="small_score"
                      style="width: 74px;margin-right: 10px"
                      v-model="majormes.small_score"
                      placeholder="总分"/>
                  </div>
                  <!--                  <p style="float: left;white-space: pre;">-->
                  <!--                    <span-->
                  <!--                      class="errors"-->
                  <!--                      v-if="errors.has('small_score')" >*{{ errors.first('small_score') }}</span>-->
                  <!--                  </p>-->
                </div>
                <div class="gpa-group jm-fl">
                  <div>
                    <span class="gpa-span">特殊要求:</span><el-input
                      v-validate="'max:20'"
                      name="yuyan"
                      style="width: 154px;margin-right: 20px"
                      v-model="majormes.yuyan"
                      placeholder="如听力最低要求"/>
                  </div>
                  <p style="float: left;white-space: pre;">
                    <span
                      class="errors"
                      v-if="errors.has('yuyan')" >*{{ errors.first('yuyan') }}</span>
                  </p>
                </div>
                <div class="gpa-group jm-fl">
                  <div>
                    <span class="gpa-span">TOEFL:</span><el-input
                      v-validate="'between:0,120'"
                      name="toeflAll"
                      style="width: 74px;margin-right: 10px"
                      v-model="majormes.toefl_all"
                      placeholder="总分"/>
                  </div>
                  <p style="float: left;white-space: pre;">
                    <span
                      class="errors"
                      v-if="errors.has('toeflAll')" >*{{ errors.first('toeflAll') }}</span>
                  </p>
                </div>
                <div class="gpa-group jm-fl">
                  <div>
                    <span class="gpa-span">L:</span><el-input
                      v-validate="'between:0,30'"
                      name="listen"
                      style="width: 50px;margin-right: 10px"
                      v-model="majormes.toefl_listen"
                      placeholder="L"/>
                  </div>
                  <p style="float: left;white-space: pre;">
                    <span class="errors" v-if="errors.has('listen')" >*{{ errors.first('listen') }}</span>
                  </p>
                </div>
                <div class="gpa-group jm-fl">
                  <div>
                    <span class="gpa-span">R:</span><el-input
                      v-validate="'between:0,30'"
                      name="read"
                      style="width: 50px;margin-right: 10px"
                      v-model="majormes.toefl_read"
                      placeholder="R"/>
                  </div>
                  <p style="float: left;white-space: pre;">
                    <span class="errors" v-if="errors.has('read')" >*{{ errors.first('read') }}</span>
                  </p>
                </div>
                <div class="gpa-group jm-fl">
                  <div>
                    <span class="gpa-span">W:</span><el-input
                      v-validate="'between:0,30'"
                      name="write"
                      style="width: 50px;margin-right: 10px"
                      v-model="majormes.toefl_write"
                      placeholder="W"/>
                  </div>
                  <p style="float: left;white-space: pre;">
                    <span class="errors" v-if="errors.has('write')" >*{{ errors.first('write') }}</span>
                  </p>
                </div>
                <div class="gpa-group jm-fl">
                  <div>
                    <span class="gpa-span">S:</span><el-input
                      v-validate="'between:0,30'"
                      name="say"
                      style="width: 50px;margin-right: 10px"
                      v-model="majormes.toefl_say"
                      placeholder="S"/>
                  </div>
                  <p style="float: left;white-space: pre;">
                    <span
                      class="errors"
                      v-if="errors.has('say')" >*{{ errors.first('say') }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="last">
              <div>
                <span class="gpa-span">
                  <i class="annotation">*</i>
                  学费(<jm-dict-select
                    class="jm-fl"
                    type="dataset"
                    :show="true"
                    v-model="majormes.country_id"
                    dict-type="student"
                    name="countryMoney"/>/年):
                </span>
                <el-input
                  v-validate="'required|tuitionFee'"
                  v-model="majormes.xuefei"
                  name="tuitionFee"
                  placeholder="请输入内容"
                  style="margin-right: 5%;width: 150px"/>
                <p><span class="errors" v-if="errors.has('tuitionFee')" >*{{ errors.first('tuitionFee') }}</span></p>
              </div>
              <div>
                <span class="gpa-span">
                  <i class="annotation">*</i>开学期:
                </span>
                <el-date-picker
                  v-validate="'required|yearAndmounth'"
                  v-model="yearAndmounth"
                  name="yearAndmounth"
                  type="month"
                  @change="changeData"
                  format="yyyy-MM"
                  placeholder="选择月"/>
                <p><span class="errors" v-if="errors.has('yearAndmounth')" >*{{ errors.first('yearAndmounth') }}</span></p>
              </div>
            </div>
            <el-checkbox
              style="margin-bottom: 20px"
              v-model="isShowing">是否在offer库里面显示</el-checkbox>
          </div>
          <div
            class="wrap-float"
            v-if="majormes.schoolname === ''">
            <p>输入目标学校中文名方可编辑目标专业!</p>
          </div>
          <el-dialog
            class="message-dialog"
            title="提示信息"
            :visible.sync="dialogVisiblepopover">
            <div class="conditions">
              <span style="float:left;">目标学校:
                <jm-Search
                  clearable
                  class="jm-input230"
                  v-model="currentRowSearch"
                  get-value="schoolname"
                  :get-other-value="['schoolname', 'sh_id']"
                  get-type="sh_name_cn"
                  :getother-type="['sh_name_cn', 'sh_id']"
                  :is-doble="true"
                  :country-id="majormes.country_id"
                  get-url='/index/api_base/searchSchool'
                />
              </span>
            </div>
            <div class="conditions">
              <div style="float: left">
                <span>专业名称:</span>
                <el-input
                  :on-icon-click="clearInput"
                  :icon="icon"
                  style="margin-right: 5px"
                  v-model="currentRowSearch.zhuanye_name"
                  placeholder="请输入内容"/>
                <el-button
                  type="primary"
                  @click="showOtheroffer()">查询</el-button>
              </div>
            </div>
            <p>以下历史录入专业信息供您选择，单击列表页对应专业查看预览信息，点击选择该专业</p>
            <el-table
              ref="singleTable"
              class="table1"
              :data="otherData"
              max-height="250"
              border
              highlight-current-row
              @current-change="handleCurrentChange"
              style="width: 100%">
              <el-table-column
                label="专业名称"
                width="300"
              >
                <template slot-scope="scope">
                  <!--<span style="margin-left: 10px" :title="scope.row.zhuanye_name">{{ scope.row.zhuanye_name }}</span>-->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.zhuanye_name"
                    placement="top-start">
                    <span>{{ scope.row.zhuanye_name }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label="意向课程">
                <template slot-scope="scope">
                  <jm-dict-select
                    v-model="scope.row.custom_course "
                    :show="true"
                    type="online"
                    :pid="majormes.country_id"
                    dict-type="course"/>
                </template>
              </el-table-column>
              <el-table-column
                property="xuewei_type"
                label="学位类型"/>
              <el-table-column
                property="sayer_name"
                label="创建人"/>
              <el-table-column
                property="copy_count"
                label="复制次数"
              />
              <el-table-column
                label="创建时间"
                width="250">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.add_time | formatDate }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="copy-btn">
              <el-button
                type="success"
                @click="chooseThis(indexSchool)">复制</el-button>
            </div>
            <div
              class="preview"
              v-if="this.currentRow">
              <div class="preview1">
                <div class="jm-fl">
                  <span class="title">意向课程:</span>
                  <jm-dict-select
                    v-model="currentRow.custom_course"
                    :show="true"
                    type="online"
                    :pid="majormes.country_id"
                    dict-type="course"/>
                </div>
                <div class="jm-fl">
                  <span class="title">专业方向:</span>
                  <jm-dict-select
                    v-model="currentRow.custom_hope_way "
                    :show="true"
                    type="college"
                    dict-type="direction"/>
                </div>
                <div
                  class="jm-fl"
                  v-if="majormes.country_id !== 673">
                  <div class="jm-fl">
                    <span class="jm-fl title">申请费用</span>
                    (<jm-dict-select
                      class="jm-fl"
                      type="dataset"
                      :show="true"
                      v-model="majormes.country_id"
                      dict-type="student"
                      name="countryMoney"/>):
                  </div>
                  <span>{{ currentRow.shenqing_xuefei | iskong }}</span>
                </div>
              </div>
              <div class="preview2">
                <div class="jm-fl">
                  <span class="jm-fl title">申请专业:</span>
                  <!--<p class="jm-fl" style="overflow:hidden;max-width: 300px;white-space: nowrap;text-overflow:ellipsis">{{ currentRow.zhuanye_name | iskong}}</p>-->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="currentRow.zhuanye_name"
                    placement="top-end">
                    <span>{{ currentRow.zhuanye_name | iskong }}</span>
                  </el-tooltip>
                </div>
                <div class="jm-fl">
                  <span class="jm-fl title">学位类型:</span>
                  <span>{{ currentRow.xuewei_type | iskong }}</span>
                </div>
              </div>
              <div class="preview3">
                <div class="jm-fl">
                  <span class="jm-fl title">网址:</span>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="currentRow.weburl"
                    placement="top-end">
                    <span class="weburl jm-fl">{{ currentRow.weburl | iskong }}</span>
                  </el-tooltip>
                </div>
              </div>
              <div class="preview4">
                <div class="jm-fl">
                  <span class="title">学制:</span>
                  <span>{{ currentRow.ex2 | iskong }}</span>
                </div>
                <div class="jm-fl">
                  <span class="title">学部:</span>
                  <span>{{ currentRow.ex3 | iskong }}</span>
                </div>
              </div>
              <div class="preview5">
                <span class="title">主要课程:</span>
                <span class="kecheng">{{ currentRow.zhuyaokecheng | iskong }}</span>
              </div>
              <div class="preview5">
                <span class="title">录取要求:</span>
                <span class="kecheng">{{ currentRow.ex1 | iskong }}</span>
              </div>
              <div class="preview6">
                <p
                  style="padding: 0 6px"
                  class="title">语言要求:</p>
                <div class="jm-fl">
                  <span class="title">IELTS:</span>
                  <span>{{ currentRow.ielts_pro | iskong }}</span>
                </div>
                <div class="jm-fl">
                  <span class="title">各小分不低于:</span>
                  <span>{{ currentRow.small_score | iskong }}</span>
                </div>
                <div
                  class="jm-fl"
                  style="margin-right: 20px">
                  <span class="title">特殊要求:</span>
                  <span>{{ currentRow.yuyan | iskong }}</span>
                </div>
                <div class="jm-fl">
                  <span class="title">TOEFL:</span>
                  <span>{{ currentRow.toefl_all | iskong }}</span>
                </div>
                <div class="jm-fl">
                  <span class="title">L:</span>
                  <span>{{ currentRow.toefl_listen | iskong }}</span>
                </div>
                <div class="jm-fl">
                  <span class="title">R:</span>
                  <span>{{ currentRow.toefl_read | iskong }}</span>
                </div>
                <div class="jm-fl">
                  <span class="title">W:</span>
                  <span>{{ currentRow.toefl_write | iskong }}</span>
                </div>
                <div class="jm-fl">
                  <span class="title">S:</span>
                  <span>{{ currentRow.toefl_say | iskong }}</span>
                </div>
              </div>
              <div class="preview7">
                <div class="jm-fl">
                  <span class="title">学费(<jm-dict-select
                    class="jm-fl"
                    type="dataset"
                    :show="true"
                    v-model="majormes.country_id"
                    dict-type="student"
                    name="countryMoney"/>/年):</span>
                  <span>{{ currentRow.xuefei | iskong }}</span>
                </div>
                <div class="jm-fl">
                  <span class="title">开学期:</span>
                  <span v-if="currentRow.kaixueqi_year !== 0">{{ currentRow.kaixueqi_year }}年{{ currentRow.kaixueqi_month }}月</span>
                  <span v-else>暂无</span>
                </div>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import popover from '@/components/order/popoverDuplicate';
import { jmSearch, jmDictSelect } from '@/components/tool';
import * as moment from 'moment';
import { Validator } from 'vee-validate';

export default {
  props: {
    aschoolList: {
      type: Array,
    },
    indexTab: {
      type: [String, Number],
    },
    indexSchool: {
      type: Number,
    },
    showWhich: {
      type: String,
    },
    majormes: {
      type: Object,
    },
    arry: {
      type: Array
    },
    canSave: {
      type: Boolean,
      default: true
    },
    shCountry: {
      type: Number,
    },
  },
  data() {
    return {
      dialogVisiblepopover: false,
      input: '',
      val: '1',
      popTitle: '申请编号',
      value: '',
      value4: '',
      textarea3: '',
      isShowing: null,
      majorInfo: {},
      yearAndmounth: '',
      otherData: {},
      currentRow: null,
      currentRowSearch: {
        zhuanye_name: '',
        sh_id: 0,
        schoolname: '',
      },
    };
  },
  computed: {
    icon() {
      return this.currentRowSearch.zhuanye_name === '' ? '' : 'circle-close';
    },
  },
  filters: {
    formatDate(value) {
      return new Date(Number(value) * 1000).toLocaleString('chinese', { hour12: false });
    },
    iskong(value) {
      if (value === '' || value === null || value === undefined || value === 0 || value === '0') {
        return '暂无';
      }
      return value;
    }
  },
  methods: {
    StartDate() {
      if (this.majormes.kaixueqi_year !== 0) {
        return `${this.majormes.kaixueqi_year}-${this.majormes.kaixueqi_month}`;
      }
      return '';
    },
    filterPid(item) {
      console.log('country_id', item.pid, this.majormes.country_id);
      return item.pid === this.majormes.country_id;
    },
    getPid(item) {
      console.log('shCountry', item.pid, this.shCountry);
      if (item.pid === this.shCountry) {
        return true;
      }
      return false;
    },
    clearInput() {
      // 复制专业方法
      this.currentRowSearch.zhuanye_name = '';
      this.showOtheroffer();
    },
    getDatasetDatasource() {
      // 复制专业方法
      return import('@/dataset/student');
    },
    chooseThis(index) {
      // 复制专业方法
      this.$set(this.currentRow, 'copy_offer_school_id', this.currentRow.id);
      this.$set(this.currentRow, 'is_copy', 1);
      this.$set(this.currentRow, 'isshow', 2);
      this.currentRow.id = this.majormes.id;
      this.majormes = this.currentRow;
      this.arry[index] = this.currentRow;
      this.checkZero();
      this.$message.success('复制成功');
      this.dialogVisiblepopover = false;
    },
    handleCurrentChange(val) {
      // 复制专业方法
      this.currentRow = val;
    },
    checkout() {
      // 本页验证方法
      return new Promise((resolve) => {
        if (this.majormes.schoolname !== '') {
          this.$validator.validateAll().then((result) => {
            this.majormes.iscan = result;
            resolve(result);
          });
          return true;
        }
        return resolve(true);
      });
    },
    // 删除院校
    delSchoolList(shId, index, candel, tab, zhuanyeid) {
      this.$confirm('此操作将永久删除该学生目标专业信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (candel !== false) {
            // 删除学校借口 crm_id 学校对应的id 后台传的可以用请求删除
            this.$http
              ._post({
                url: 'index/offer/delProfessional',
                data: {
                  crm_id: this.$route.params.id,
                  sh_id: shId,
                  id: zhuanyeid
                }
              })
              .then((data) => {
                if (data) {
                  this.$message.success('删除成功');
                  this.aschoolList[tab].splice(index, 1);
                }
              });
          } else {
            this.$message.success('删除成功');
            this.aschoolList[tab].splice(index, 1);
          }
        });
    },
    changeData(val) {
      if (val === '' || typeof val === 'undefined') {
        this.majormes.kaixueqi_year = '';
        this.majormes.kaixueqi_month = '';
      } else {
        this.majormes.kaixueqi_year = moment(val).format('YYYY');
        this.majormes.kaixueqi_month = moment(val).format('MM');
      }
    },
    yanzhenghope () {
      const dictionary = {
        zh_CN: {
          messages: {
            required: (field) => { return `请输入${field}`; },
            between: (filed, data) => { return `${filed}应该在${data[0]} 到 ${data[1]}之间`; },
            max: (filed, data) => { return `${filed}应再${data}字以内`; }
          },
          attributes: {
            customCourse: '意向课程',
            customHopeWay: '专业方向',
            zhuanyeName: '申请专业',
            xueweiType: '学位类型',
            weburl: '网址',
            ieltsPro: 'IELTS',
            yuyan: '特殊要求',
            toeflAll: 'toefl',
            listen: '听力',
            read: '阅读',
            say: '口语',
            write: '写作',
            small_score: '各小分不低于',
            inputEx2: '学制',
            inputEx3: '学部',
            tuitionFee: '学费',
            yearAndmounth: '开学期',
            mainCourses: '主要课程',
            inputEx1: '申请要求',
            applyMoney: '申请费用',
            inputMemo: '备注'
          }
        }
      };
      Validator.localize(dictionary);
    },
    showOtheroffer(status = false) {
      this.$emit('chageActiveNames', this.indexSchool);
      if (status) {
        this.currentRowSearch.schoolname = this.majormes.schoolname;
        this.currentRowSearch.zhuanye_name = this.majormes.zhuanye_name;
        this.currentRowSearch.sh_id = this.majormes.sh_id;
      }
      this.$http._post({
        url: '/index/offer/getCopyOfferList',
        data: this.currentRowSearch,
      }).then((data) => {
        this.otherData = data.data;
        this.currentRow = this.otherData[0];
        this.dialogVisiblepopover = true;
        this.$nextTick(() => {
          this.$refs.singleTable.setCurrentRow(this.otherData[0]);
        });
      });
    },
    xinxilan(v) {
      if (this.majormes.country_id === 673) {
        if (v === 1852) {
          this.majormes.ex2 = '';
        } else if (v === 1855 || v === 1854 || v === 1864 || v === 1865) {
          this.majormes.ex2 = '1 year full time';
        } else if (v === 1853) {
          this.majormes.ex2 = '3 years full time';
        } else if (v === 1856) {
          this.majormes.ex2 = '1.5 years full time';
        }
      }
    },
    checkZero() {
      if (this.majormes.ielts_pro === 0 || this.majormes.ielts_pro === '0') {
        this.majormes.ielts_pro = '';
      }
      if (this.majormes.yuyan === 0 || this.majormes.yuyan === '0') {
        this.majormes.yuyan = '';
      }
      if (this.majormes.toefl_all === 0 || this.majormes.toefl_all === '0') {
        this.majormes.toefl_all = '';
      }
      if (this.majormes.toefl_listen === 0 || this.majormes.toefl_listen === '0') {
        this.majormes.toefl_listen = '';
      }
      if (this.majormes.toefl_read === 0 || this.majormes.toefl_read === '0') {
        this.majormes.toefl_read = '';
      }
      if (this.majormes.toefl_say === 0 || this.majormes.toefl_say === '0') {
        this.majormes.toefl_say = '';
      }
      if (this.majormes.toefl_write === 0 || this.majormes.toefl_write === '0') {
        this.majormes.toefl_write = '';
      }
      // if (this.majormes.shenqing_xuefei === 0 || this.majormes.shenqing_xuefei === '0') {
      //   this.majormes.shenqing_xuefei = '';
      // }
      // if (this.majormes.small_score === 0 || this.majormes.small_score === '0') {
      //   this.majormes.small_score = '';
      // }
      // if (this.majormes.xuefei === 0 || this.majormes.xuefei === '0') {
      //   this.majormes.xuefei = '';
      // }
      if (this.majormes.custom_hope_way === 0 || this.majormes.custom_hope_way === '0') {
        this.majormes.custom_hope_way = '';
      }
      if (this.majormes.custom_course === 0 || this.majormes.custom_course === '0') {
        this.majormes.custom_course = '';
      }
    },
  },
  components: {
    'jm-popover': popover,
    jmSearch,
    jmDictSelect,
    Validator
  },
  mounted() {
    // this.getDatasetDatasource().then((ds) => {
    //   ds.shCountry.forEach((item) => {
    //     if (item.value === this.majormes.country_id) {
    //       this.shcountry = item.label;
    //     }
    //   });
    // });
    if (this.majormes.isshow === 1) {
      this.isShowing = true;
    } else {
      this.isShowing = false;
    }
    this.yearAndmounth = this.StartDate();
    // if (this.majormes.kaixueqi_year !== 0) {
    //   this.yearAndmounth = `${this.majormes.kaixueqi_year}-${this.majormes.kaixueqi_month}`;
    // } else {
    //   this.yearAndmounth = '';
    // }
    this.currentRowSearch.schoolname = this.majormes.schoolname;
    this.currentRowSearch.sh_id = this.majormes.sh_id;
    this.currentRowSearch.zhuanye_name = this.majormes.zhuanye_name;
    this.yanzhenghope();
    this.checkZero();
  },
  watch: {
    majormes: {
      handler: function () {
        this.checkZero();
        this.yearAndmounth = this.StartDate();
      },
      deep: true
    },
    isShowing(val) {
      if (val) {
        this.majormes.isshow = 1;
      } else {
        this.majormes.isshow = 2;
      }
    },
    'majormes.custom_course': {
      handler: function (v) {
        let val = v === '' ? '0' : v;
        this.$validator.validate('customCourse', val);
        this.xinxilan(v);
      },
      deep: true
    },
    // 'majormes.custom_hope_way': {
    //   handler: function (v) {
    //     let val = v === '' ? '0' : v;
    //     this.$validator.validate('customHopeWay', val);
    //   },
    //   deep: true
    // },
    'majormes.zhuanye_name': {
      handler: function (v) {
        let val = v === '' ? '0' : v;
        this.$validator.validate('zhuanyeName', val);
      },
      deep: true
    },
    // 'majormes.xuewei_type': {
    //   handler: function (v) {
    //     if (this.majormes.country_id !== 673) {
    //       let val = v === '' || v === undefined ? '0' : v;
    //       this.$validator.validate('xueweiType', val);
    //     }
    //   },
    //   deep: true
    // },
    // 'majormes.shenqing_xuefei': {
    //   handler: function (v) {
    //     if (this.majormes.country_id !== 673) {
    //       let val = v === '' || v === undefined ? '0' : v;
    //       this.$validator.validate('applyMoney', val);
    //     }
    //   },
    //   deep: true
    // },
    // 'majormes.zhuyaokecheng': {
    //   handler: function (v) {
    //     let val = v === '' || v === undefined ? '' : v;
    //     this.$validator.validate('mainCourses', val);
    //   },
    //   deep: true
    // },
    // 'majormes.ex1': {
    //   handler: function (v) {
    //     let val = v === '' || v === undefined ? '' : v;
    //     this.$validator.validate('inputEx1', val);
    //   },
    //   deep: true
    // },
    'majormes.ex2': {
      handler: function (v) {
        let val = v === '' || v === undefined ? '0' : v;
        this.$validator.validate('inputEx2', val);
      },
      deep: true
    },
    // 'majormes.ex3': {
    //   handler: function (v) {
    //     let val = v === '' || v === undefined ? '0' : v;
    //     this.$validator.validate('inputEx3', val);
    //   },
    //   deep: true
    // },
    'majormes.xuefei': {
      handler: function (v) {
        let val = v === '' || v === undefined ? '0' : v;
        this.$validator.validate('tuitionFee', val);
      },
      deep: true
    },
    'majormes.kaixueqi_year': {
      handler: function (v) {
        let val = v === '' || v === undefined ? '' || v === 0 : v;
        this.$validator.validate('yearAndmounth', val);
      },
      deep: true
    },
    'majormes.weburl': {
      handler: function (v) {
        let val = v === '' ? '0' : v;
        this.$validator.validate('weburl', val);
      },
      deep: true
    },
  },
  created() {
    Validator.extend('customCourse', {
      getMessage: (field) => { return `请输入${field}`; },
      validate: (value) => {
        return value !== '0';
      }
    });
    // Validator.extend('customHopeWay', {
    //   getMessage: (field) => { return `请输入${field}`; },
    //   validate: (value) => {
    //     return value !== '0' && value !== '';
    //   }
    // });
    // Validator.extend('applyMoney', {
    //   getMessage: (field) => { return `请输入${field}`; },
    //   validate: (value) => {
    //     if (this.majormes.country_id !== 673) {
    //       return value !== '';
    //     }
    //     return true;
    //   }
    // });
    // Validator.extend('xueweiType', {
    //   getMessage: (field) => { return `请输入${field}`; },
    //   validate: (value) => {
    //     if (this.majormes.country_id !== 673) {
    //       return value !== '0';
    //     }
    //     return true;
    //   }
    // });
    // Validator.extend('mainCourses', {
    //   getMessage: (field) => { return `请输入${field}`; },
    //   validate: (value) => {
    //     if (this.majormes.country_id === 30 || this.majormes.country_id === 31) {
    //       return value !== '';
    //     }
    //     return true;
    //   }
    // });
    // Validator.extend('inputEx1', {
    //   getMessage: (field) => { return `请输入${field}`; },
    //   validate: (value) => {
    //     if (this.majormes.country_id === 30 || this.majormes.country_id === 31) {
    //       return value !== '';
    //     }
    //     return true;
    //   }
    // });
    Validator.extend('inputEx2', {
      getMessage: (field) => { return `请输入${field}`; },
      validate: (value) => {
        if (this.majormes.country_id === 30 || this.majormes.country_id === 31) {
          return value !== '0' && value !== '';
        }
        return true;
      }
    });
    // Validator.extend('inputEx3', {
    //   getMessage: (field) => { return `请输入${field}`; },
    //   validate: (value) => {
    //     if (this.majormes.country_id === 30 || this.majormes.country_id === 31) {
    //       return value !== '0' && value !== '';
    //     }
    //     return true;
    //   }
    // });
    Validator.extend('tuitionFee', {
      getMessage: (field) => { return `请输入${field}`; },
      validate: (value) => {
        return value !== '';
      }
    });
    Validator.extend('yearAndmounth', {
      getMessage: (field) => { return `请输入${field}`; },
      validate: (value) => {
        return value !== 0 && value !== '0' && value !== '';
      }
    });
    Validator.extend('zhuanyeName', {
      getMessage: (field) => { return `请输入${field}`; },
      validate: (value) => {
        return value !== '0';
      }
    });
    Validator.extend('weburl', {
      getMessage: (field) => { return `请输入${field}`; },
      validate: (value) => {
        return value !== '0';
      }
    });
    Validator.extend('all', {
      // IELTS 小数点1一位切必须是.5
      getMessage: (field) => { return `${field}保留一位且.5`; },
      validate: (value) => {
        if (Number(value) % 1 !== 0) {
          let nVal = String(value).split('.');
          return nVal[1].length === 1 && nVal[1] === '5';
        }
        return true;
      }
    });
  }
};
</script>
<style >

  .last>div{
    width: 50%;
    float: left;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .el-table th>.cell{
    text-align: center;
  }
  .check-group{
    min-height: 10px;
  }
  .message-dialog .el-dialog{
    width: 80%;
  }
  .el-dialog--small{
    width: 80%;
  }
  .el-table .cell{
    text-align: center;
  }
  .professional>div:after{
    display: block;
    content: '';
    clear: both;
    visibility: hidden;
    opacity:0;
  }
  .result>p{
    color: #ff3f3f;
    padding-left:4px ;
  }
  .hide>div:after{
    display: block;
    content: '';
    clear: both;
    opacity:0;
    height:0;
  }
  .el-collapse-item__content{
    position: relative;
  }
  .professional .spceial .el-collapse-item__header:hover{
    background-color: #fff!important;
  }
  .conditions{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
</style>
<style scoped>
  .title{
    font-weight: 900;
    color: #333;
  }
  .preview3 .weburl{
    display: block;
    max-width: 95%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .preview3>div{
    max-width: 100%;
  }
  .preview2 .item{
    display: block;
    float: left;
    overflow:hidden;
    max-width: 300px;
    white-space: nowrap;
    text-overflow:ellipsis;
  }
  .preview5 .kecheng{
    white-space: inherit;
  }
  .conditions:after{
    display: block;
    content: '';
    clear: both;
    opacity:0;
  }

  .conditions>div{
    display: flex;
    align-items: center;
  }
  .isyes{
    background: url(../../../assets/images/curry.png) no-repeat 0 -19px;;
    width: 26px;
    height: 28px;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 0;
  }
  .preview>div{
    padding-bottom: 5px;
  }
  .preview:after{
    display: block;
    content: '';
    clear: both;
    opacity: 0;
    height: 0;
  }
  .preview>div:after{
    display: block;
    content: '';
    clear: both;
    opacity: 0;
    height: 0;
  }
  .preview>div>div{
    padding:0 6px;
    border-right: 1px solid #ccc;
  }
  .preview5{
    display: flex;
  }
  .preview>.preview5>div{
    border: none;
    padding: 0;
  }
  .preview span{
    padding: 0;
  }
  .preview5>span{
    padding: 0 6px;
  }
  .copy-btn{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }
  .table1 .el-table__body-wrapper tr{
    cursor: pointer;
  }
  .degreeType .prompting-wapper{
    width: 50%;
  }
  .prompting-wapper{
    float: left;
    height: auto;
  }
  .degreeType .inputWrap{
    width:100%;
  }
  .coll .inputWrap {
    width: 50%;
  }
  .tit-wapper-per{
    display: flex;
    align-items: center;
    justify-content: left;
    width: 35%;
    height:100%;
    float: left;
    background: #01142d;
    line-height:40px;
    color:#fff;
    box-sizing: border-box;
    padding:0 10px;
    padding-left: 30px;
    margin-right: 20px;
    position: relative;
  }
  .tit-wapper-per span{
    color: #fff;
    display: block;
    float: left;
    width: 100%;
    overflow:hidden;
    text-overflow: ellipsis
  }
  .tit-wapper-per  i{
    color: #fff;
  }
  .wrap-float{
    height: calc(100% - 46px);
    width: 100%;
    position: absolute;
    top: 46px;
    left: 0;
    background: rgba(0,0,0,.4);
    z-index:2;
  }
  .wrap-float p{
    width: 300px;
    height: 20px;
    line-height: 20px;
    color: red;
    font-size: 16px;
    position: absolute;
    top: 50%;
    margin-top: -10px;
    left: 50%;
    margin-left: -150px;
  }
</style>
